export type ISlotStatus = "staking" | 'unstaking' | 'unknown'

export function mapStakingStatusToValue(status: ISlotStatus) {
  if (status === "staking") return 1;
  if (status === "unstaking") return 2;
}